import { GET_CURRENT_USER } from '@/Graphql/queries';
import { getRoutes } from '@/routes/routePaths';
import { authState } from '@/vars/auth';
import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useCurrentUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getCurrentUser] = useLazyQuery(GET_CURRENT_USER, {
    onCompleted: (res) => {
      const user = res?.getCurrentUser;
      authState({
        authenticated: true,
        loading: false,
        userDetails: user,
      });
      if (res?.getCurrentUser?.role && res.getCurrentUser.firstName && res.getCurrentUser.email) {
        // if (res?.getCurrentUser?.role !== Role.Trainee) {
        //   navigate(getRoutes.Sessions);
        // }
      } else {
        navigate(getRoutes.SignUp);
      }
    },
    fetchPolicy: 'network-only',
  });
  // Routes that are intentionally public — no login redirect on these paths
  const PUBLIC_PATHS = [getRoutes.GiftCard];
  const isPublicPath = PUBLIC_PATHS.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (localStorage.getItem('accessToken')) {
      getCurrentUser();
    } else {
      authState({
        authenticated: false,
        loading: false,
      });
      if (!isPublicPath) {
        navigate(`${getRoutes.Login}${location.search}`);
      }
    }
    return () => {};
  }, []);
};
